import { createSlice } from '@reduxjs/toolkit';
import { SESSION_STORAGE_KEYS } from '../../constants/sessionStorageKeys';
import { SLICES } from '../../constants/slices';

const initialState = {
  termsOfUsePopupVisible: sessionStorage.getItem(SESSION_STORAGE_KEYS.SHOW_TERMSOFUSE) !== 'false' || true
};
const dashboardSlice = createSlice({
  name: SLICES.DASHBOARD,
  initialState,
  reducers: {
    setTermsOfUsePopupVisible: (state, action) => {
      state.termsOfUsePopupVisible = action.payload;
      sessionStorage.setItem(SESSION_STORAGE_KEYS.SHOW_TERMSOFUSE, state.termsOfUsePopupVisible);
    }
  }
});
export const { setTermsOfUsePopupVisible } = dashboardSlice.actions;

export default dashboardSlice.reducer;
